import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard для проверки наличия роли у пользователя
 * Перенаправляет на /assign-role если у авторизованного пользователя нет нужной роли
 */
export const needsRoleGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Только для авторизованных пользователей
  if (!authService.isAuthenticated()) {
    return true;
  }

  if (authService.needsRoleAssignment()) {
    router.navigate(['/assign-role']);
    return false;
  }

  return true;
};
